export default {
  path: '/lvy-let-sign-face',
  component: () => import('./LVYLetSignFace'),
  meta: {
    title: '人脸信息处理规则',
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}